module.exports = __webpack_public_path__ + "img/cross-icon.4e5e8696.svg";